import React, { createContext, useContext } from "react";
import { translations } from "@/lib/i18n";

// Norwegian-only mode: no toggle, no English fallback
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const lang = "no";

  const t = (key) => translations.no[key] || key;

  // Kept for API compatibility but no-op
  const toggle = () => {};
  const setLang = () => {};

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
};
